import AppLogo from "@/components/AppLogo";
import { buttonVariants } from "@/components/ui/button/button";
import Typography from "@/components/ui/typography";
import { useAuth } from "@/context/auth-context";
import { Link, useLoaderData } from "@tanstack/react-router";
import { User, XIcon } from "lucide-react";
import React from "react";

interface Props {
	children: React.ReactNode;
}

export default function UserVerifiedAuthGuard(props: Props) {
	const { children } = props;
	const { user } = useAuth();

	const { name } = useLoaderData({ from: "__root__" });
	if (!user.has_verified_identity) {
		return (
			<div className="kashu-container h-[100dvh] max-h-[100dvh] flex flex-col">
				<Link
					to={"/main/home"}
					className={buttonVariants({
						variant: "unstyled",
						className: "absolute top-4 right-4",
					})}
				>
					<XIcon className="w-6 h-6" />
				</Link>

				<div className="mb-10 flex items-center justify-center pt-6">
					<AppLogo />
				</div>

				<div className="flex-1 flex flex-col justify-between pb-6">
					<div className="text-center">
						<Typography variant={"h1"} className="mb-4">
							You haven't verified your identity yet.
						</Typography>
						<Typography variant={"p"} className="mt-1">
							In order to use {name}, you need to verify your identity.
						</Typography>
					</div>

					<Link
						to={"/main/verify-identity"}
						className={buttonVariants({
							variant: "default",
							className: "mt-8 w-full",
						})}
					>
						Verify your identity <User />
					</Link>
				</div>
			</div>
		);
	}

	return children;
}
